import { render } from "./ProducerAbilities.vue?vue&type=template&id=6f2030b0"
import script from "./ProducerAbilities.vue?vue&type=script&lang=js"
export * from "./ProducerAbilities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__